import { ArtifactsManager } from '@/components/artifacts/ArtifactsManager';
import { isStructureEditable as isEventStructureEditable } from '@/components/events/eventLifecycle';
import { useEventContext } from '@/pages/events/useEventContext';
import { Skeleton } from '@startupquickstart/frontend';

/**
 * Event Artifacts tab — thin wrapper around the shared owner-scoped
 * ArtifactsManager (also used by TemplateArtifactsTab). With
 * `keyPrefix='Event'` and `apiBase=/events/:id` the manager's query keys
 * and endpoints are byte-identical to this tab's original inline
 * implementation.
 */
export function EventArtifactsTab() {
  const { event, isLoading } = useEventContext();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Skeleton className="h-7 w-32" />
          <Skeleton className="h-9 w-36" />
        </div>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-32 rounded-xl" />
        ))}
      </div>
    );
  }

  if (!event) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Event not found</p>
      </div>
    );
  }

  return (
    <ArtifactsManager
      ownerId={event.id}
      apiBase={`/events/${event.id}`}
      keyPrefix="Event"
      structureEditable={isEventStructureEditable(event.status)}
      lockedDescription={`This event is ${event.status}. Artifact placement is locked, but you can toggle active state.`}
    />
  );
}
